// roles.constants.ts
export const ROLES = {
    CUSTOMER: 'cstr',
    AGENT: 'agnt',
    BUS_OPS_ADMIN: 'bus-ops-admin',
} as const;